<template>

    <div class="about">

        <div class="about-text">
            <p>
                {{ $t('txtAbout1') }}                
                <br /><br />
                {{ $t('txtAbout2') }}<a href="https://www.linkedin.com/in/yogabyian">LinkedIn</a>.
            </p>
        </div>

        <div class="about-img">
            <img id="classes" alt="Yoga By Ian" src="../../assets/images/studio-bikes-0.1.png">
        </div>

    </div>

</template>
  
<script setup>

</script>

<style>

    .about {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        padding-left: 20px;
        padding-bottom: 20px;
    }

    .about-text {
        flex: 1 1 200px;
        font-size: 18px;
        text-align: left;
        padding-top: 0px;
        padding-left: 20px;
        padding-right: 20px;
    }

    .about-img {
        flex: 0 0 240px;
        padding-right: 60px;
    }

    .about-img img {
        width: 240px;
    }

    @media screen and (max-width: 600px) {
        
        .about {
            justify-content: center;
        }

        .about-text {
            flex: 1 1 100px;
            font-size: 14px;
            text-align: left;
            padding-top: 0px;
            padding-left: 0px;
            padding-right: 20px;
        }
    }

</style>
